<template>
    <div class="image" :class="{active: isFocus}" ref="imageElement">
        <div class="deleteBtn" @click.prevent="remove()"> X </div>
        <div class="wrapper">
            <ImageCanvas :imageData="data.imageData" :size="320"/>
            <div style="width: 100%; height: 100%; position: absolute; pointer-events: none;">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import ImageCanvas from '@/tm/ImageCanvas.vue';

export default{
    components: {
        ImageCanvas
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        isFocus: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        remove(){
            this.$emit('remove')
        },
    },
}
</script>


<style scoped>
.image{
    width: 70.5px;
    min-width: 70.5px; height: 70.5px; border: 2px solid #8a66c7;
    transition: .1s all ease-in-out;
    cursor: pointer;

}

.wrapper{
    opacity: 0.3;
}

.image:not(.active):hover .wrapper{
    opacity: 0.7;
}

.image.active .wrapper{
    opacity: 1;
}

.deleteBtn{
    width: 25px; height: 25px; border: 2px solid red; position: absolute; z-index: 1; top: 3px; right: 3px; color: red; 
    display: flex; justify-content: center; align-items: center; 
    opacity: 0;
    transition: all .15s ease-in-out;
    background: rgba(255, 255, 255, 0.7);
}

.deleteBtn:hover{
    background: rgba(255, 255, 255, 1);
}

.image:hover .deleteBtn{
    opacity: 1;
}
</style>